import React, { useContext, useEffect, useRef, useState, useCallback } from 'react';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Spinner } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import Select from "react-select";
import Swal from "sweetalert2";

import { AuthContext } from '../../context/AuthContext';
import { RelatorioVendaContext } from '../../context/RelatorioVendaContext';
import { RelatorioVendaType, CreateRelatorioVendaType, EditRelatorioVendaType, AlunoVendedorType, CreateRelacaoRelatorioVendaType, EditRelacaoRelatorioVendaType, AtualizarStatusRelatorioVendaRequest, AlterarVendedorRelatorioRequest } from '../../context/hooks/useRelatorioVenda';
import { ContratoContext } from '../../context/ContratoContext';
import { AlunoContext } from '../../context/AlunoContext';
import { TerceiroContext } from '../../context/TerceiroContext';
import api from '../../api';

import useUser from '../../context/hooks/useUser';
import { createPermissionChecker, PermissionModule } from '../../types/permissions';
import { set } from 'lodash';
import { AlunoType } from '../../context/hooks/useAluno';
import ModalConfirm from '../../components/ModalConfirm/ModalConfirm';

const RelatorioVenda = () => {
    const { objUserTk } = useContext(AuthContext);
    const { getRelatorioVendaPaged, listRelatorioVenda, relatorioVendaPageCount, createRelatorioVenda, updateRelatorioVenda, deleteRelatorioVenda, getAlunosVendedoresByRelatorioId, adicionarRelacoesAoRelatorio, updateRelacoesRelatorioVenda, removerRelacaoRelatorioVenda, downloadRelatorioVendaPdf, downloadRelatorioReduzidoVendaPdf, getRelatorioVendaPdfBlob, getRelatorioReduzidoVendaPdfBlob, getAlunosVendedoresPaged, listRelacaoAlunosVendedores, relacaoAlunosVendedoresPageCount, atualizarStatusLote, alterarVendedorRelatorio, validarAlunoEmOutroRelatorioEmRota, validarVendedorComContratosAbertos, validarAlunoPertenceAoContrato, downloadRelatorioVendasAtivasPdf, downloadRelatorioMultiplosPdf } = useContext(RelatorioVendaContext)
    const { getAlunoPaged, setListAluno, listAluno, alunoPageCount, setAlunoPageCount, handleGetAlunoById, handleGetAlunoByReferenceCode } = useContext(AlunoContext);
    const { handleGetVendedoresByEmpresa, listVendedores } = useContext(TerceiroContext);
    const { handleGetContratoByEmpresaId, listContrato } = useContext(ContratoContext);
    const [loaging, setLoading] = useState(true);
    const { getPermissionsByUser, userPermissions, useLegacyPermissions, modulePermissions } = useUser();
    const hasPermission = createPermissionChecker(useLegacyPermissions, userPermissions, modulePermissions);
    const [modoRelatorio, setModoRelatorio] = useState<'porContrato' | 'porAluno'>('porContrato');
    const [buscaCodigoAluno, setBuscaCodigoAluno] = useState("");

    const [newRelatorioVenda, setNewRelatorioVenda] = useState<CreateRelatorioVendaType>({
        id: 0,
        date: "",
        status: 0,
        checked: false,
        dateChecked: "",
        empresaId: 0,
        contratoId: 0,
    });
    const [editingRelatorioVenda, setEditingRelatorioVenda] = useState<EditRelatorioVendaType | null>(null);
    const [pendingRemoverRelacao, setPendingRemoverRelacao] = useState<{ alunoId: number; vendedorId: number } | null>(null);

    const executeRemoverRelacaoRelatorioVenda = async () => {
        if (!editingRelatorioVenda || !pendingRemoverRelacao) return;
        const result = await removerRelacaoRelatorioVenda(
            editingRelatorioVenda.id,
            pendingRemoverRelacao.alunoId,
            pendingRemoverRelacao.vendedorId
        );
        if (result) {
            const atualizados = await getAlunosVendedoresByRelatorioId(editingRelatorioVenda.id);
            setAlunosVinculados(atualizados || []);
            await getAlunosVendedoresPaged(editingRelatorioVenda.id, 1, 10);
            setAlunosSelecionadosIds([]);
        }
        setPendingRemoverRelacao(null);
    };
    const [editingRelacaoRelatorioVenda, setEditingRelacaoRelatorioVenda] = useState<EditRelacaoRelatorioVendaType | null>(null);

    const [dataSearch, setDataSearch] = useState({ RelatorioId: 0, ContratoId: 0, Status: 0, InitialDate: "", FinalDate: "" });
    const [tipoFiltro, setTipoFiltro] = useState<string>("relatorioId");
    const [termoBusca, setTermoBusca] = useState<string>("");
    const [alunoSearch, setAlunoSearch] = useState({ name: "", alunoId: "" });
    const [alunoVendedorSearch, setAlunoVendedorSearch] = useState({ name: "", alunoId: "" });

    const [alunosVinculados, setAlunosVinculados] = useState<AlunoVendedorType[]>([]);
    const [relacoesAlunoVendedor, setRelacoesAlunoVendedor] = useState<CreateRelacaoRelatorioVendaType[]>([]);
    const [alunosPendentesInfo, setAlunosPendentesInfo] = useState<Record<number, { referenceCode?: number; name: string }>>({});
    const [vendedorAtivo, setVendedorAtivo] = useState<number>(0);

    const [codigoAluno, setCodigoAluno] = useState<number>(0);
    const [numeroFotos, setNumeroFotos] = useState<number>(0);
    const [codigoAlunoEdicao, setCodigoAlunoEdicao] = useState<number>(0);
    const [numeroFotosEdicao, setNumeroFotosEdicao] = useState<number>(0);
    const [nomeFormando, setNomeFormando] = useState("");
    const [nomeFormandoEdicao, setNomeFormandoEdicao] = useState("");
    const [buscandoNomeFormando, setBuscandoNomeFormando] = useState(false);
    const [buscandoNomeFormandoEdicao, setBuscandoNomeFormandoEdicao] = useState(false);
    const [isAddingAluno, setIsAddingAluno] = useState(false);
    const [isAddingAlunoEdicao, setIsAddingAlunoEdicao] = useState(false);
    const [vendedorAtivoEdicao, setVendedorAtivoEdicao] = useState<number>(0);

    const [alunosSelecionadosIds, setAlunosSelecionadosIds] = useState<number[]>([]);
    const [novoStatusLote, setNovoStatusLote] = useState<number>(0);
    const [novoVendedorLote, setNovoVendedorLote] = useState<number>(0);
    const [novoVendedorRelatorio, setNovoVendedorRelatorio] = useState<number>(0);
    const [todosSelecionados, setTodosSelecionados] = useState(false);
    // Armazena o status alterado individualmente para cada formando (relacaoId -> status)
    const [statusEmEdicaoPorAluno, setStatusEmEdicaoPorAluno] = useState<Record<number, number>>({});
    const [salvandoStatusIndividual, setSalvandoStatusIndividual] = useState(false);

    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [editRelacaoModalOpen, setEditRelacaoModalOpen] = useState(false);

    const [relatoriosSelecionadosIds, setRelatoriosSelecionadosIds] = useState<number[]>([]);

    const [exportModalOpen, setExportModalOpen] = useState(false);
    const [vendedorFiltroExport, setVendedorFiltroExport] = useState<number>(0);
    const [statusFiltroExport, setStatusFiltroExport] = useState<number>(0);
    // Datas do PDF: começam com o que estiver na busca da tela (ou vazias) e podem ser
    // ajustadas no próprio modal antes de exportar.
    const [initialDateFiltroExport, setInitialDateFiltroExport] = useState<string>("");
    const [finalDateFiltroExport, setFinalDateFiltroExport] = useState<string>("");
    const [previewModalOpen, setPreviewModalOpen] = useState(false);
    const [previewPdfUrl, setPreviewPdfUrl] = useState<string | null>(null);
    const [previewPdfTitle, setPreviewPdfTitle] = useState("");
    const [previewLoading, setPreviewLoading] = useState(false);

    const closePreviewModal = () => {
        if (previewPdfUrl) {
            URL.revokeObjectURL(previewPdfUrl);
        }
        setPreviewPdfUrl(null);
        setPreviewModalOpen(false);
    };

    const handlePreviewRelatorio = async (
        relatorioId: number,
        reduzido = false,
        vendedorId?: number,
        status?: number
    ) => {
        setPreviewLoading(true);
        setPreviewPdfTitle(`Relatório de Venda #${relatorioId}${reduzido ? ' (Reduzido)' : ''}`);
        setPreviewModalOpen(true);

        try {
            const blob = reduzido
                ? await getRelatorioReduzidoVendaPdfBlob(relatorioId, vendedorId, status)
                : await getRelatorioVendaPdfBlob(relatorioId, vendedorId, status);

            if (blob) {
                const objectUrl = URL.createObjectURL(blob);
                setPreviewPdfUrl(objectUrl);
            } else {
                Swal.fire("Atenção", "Não foi possível carregar a pré-visualização do relatório.", "warning");
                setPreviewModalOpen(false);
            }
        } catch (err) {
            console.error("Erro ao gerar preview:", err);
            Swal.fire("Erro", "Ocorreu um erro ao carregar a pré-visualização do relatório.", "error");
            setPreviewModalOpen(false);
        } finally {
            setPreviewLoading(false);
        }
    };

    const handlePrintPreview = () => {
        const iframe = document.getElementById("pdfPreviewIframe") as HTMLIFrameElement;
        if (iframe && iframe.contentWindow) {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
        }
    };

    const handleDownloadCurrentPreview = (title: string) => {
        if (!previewPdfUrl) return;
        const a = document.createElement("a");
        a.href = previewPdfUrl;
        a.download = `${title.replace(/[^a-zA-Z0-9_-]/g, "_")}.pdf`;
        a.click();
    };

    const [pageNumber, setPageNumber] = useState(1);
    const [loadingMore, setLoadingMore] = useState(false);
    const sentinelRef = useRef<HTMLDivElement | null>(null);
    const isFirstMountRelatorios = useRef(true);

    const reloadRelatorios = useCallback((targetPage = 1) => {
        if (!objUserTk?.EmpresaId) return;
        setPageNumber(targetPage);
        return getRelatorioVendaPaged(
            targetPage,
            dataSearch.RelatorioId || undefined,
            objUserTk.EmpresaId,
            dataSearch.ContratoId || undefined,
            15,
            dataSearch.Status || undefined,
            dataSearch.InitialDate || undefined,
            dataSearch.FinalDate || undefined,
            false
        );
    }, [dataSearch, objUserTk?.EmpresaId, getRelatorioVendaPaged]);

    const loadMoreRelatorios = useCallback(async () => {
        if (loadingMore || loaging || pageNumber >= relatorioVendaPageCount) return;
        setLoadingMore(true);
        const nextPage = pageNumber + 1;
        try {
            await getRelatorioVendaPaged(
                nextPage,
                dataSearch.RelatorioId || undefined,
                objUserTk?.EmpresaId,
                dataSearch.ContratoId || undefined,
                15,
                dataSearch.Status || undefined,
                dataSearch.InitialDate || undefined,
                dataSearch.FinalDate || undefined,
                true
            );
            setPageNumber(nextPage);
        } catch (err) {
            console.error("Erro ao carregar mais relatórios:", err);
        } finally {
            setLoadingMore(false);
        }
    }, [loadingMore, loaging, pageNumber, relatorioVendaPageCount, dataSearch, objUserTk?.EmpresaId, getRelatorioVendaPaged]);

    useEffect(() => {
        const sentinel = sentinelRef.current;
        if (!sentinel) return;

        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && !loaging && !loadingMore && pageNumber < relatorioVendaPageCount) {
                    loadMoreRelatorios();
                }
            },
            { threshold: 0.1, rootMargin: "150px" }
        );

        observer.observe(sentinel);
        return () => observer.disconnect();
    }, [loadMoreRelatorios, loaging, loadingMore, pageNumber, relatorioVendaPageCount]);

    useEffect(() => {
        if (!objUserTk?.EmpresaId) return;

        handleGetContratoByEmpresaId(objUserTk.EmpresaId);
        handleGetVendedoresByEmpresa(objUserTk.EmpresaId);

        // Se nenhum filtro estiver preenchido, faz a carga inicial
        const hasFilters = dataSearch.RelatorioId !== 0 || dataSearch.ContratoId !== 0 || dataSearch.Status !== 0 || Boolean(dataSearch.InitialDate) || Boolean(dataSearch.FinalDate);
        if (isFirstMountRelatorios.current && !hasFilters) {
            setLoading(true);
            setPageNumber(1);
            getRelatorioVendaPaged(1, 0, objUserTk.EmpresaId, 0, 15)
                .then(() => {
                    setLoading(false);
                })
                .catch(error => {
                    console.error("Erro ao buscar relatórios:", error);
                    setLoading(false);
                });
        }
    }, [objUserTk?.EmpresaId]);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (objUserTk?.UserId) {
                const permissions = await getPermissionsByUser(objUserTk.UserId);
            }
        };

        fetchPermissions().catch(error => console.error("Erro ao carregar permissões:", error));
    }, [objUserTk?.UserId]);

    const buscarNomeFormandoPorCodigo = async (codigo: number) => {
        if (!codigo || codigo <= 0) return "";

        const alunoCarregado = listAluno.find(aluno => Number(aluno.referenceCode) === Number(codigo));
        if (alunoCarregado) return alunoCarregado.name;

        try {
            const response = await api.get<AlunoType>(`/Aluno/getAlunoByReferenceCode/${codigo}`);
            return response.data?.name || "";
        } catch {
            return "";
        }
    };

    useEffect(() => {
        let active = true;

        if (!codigoAluno) {
            setNomeFormando("");
            setBuscandoNomeFormando(false);
            return;
        }

        const timeoutId = window.setTimeout(async () => {
            setBuscandoNomeFormando(true);
            const nome = await buscarNomeFormandoPorCodigo(codigoAluno);
            if (active) {
                setNomeFormando(nome);
                setBuscandoNomeFormando(false);
            }
        }, 150);

        return () => {
            active = false;
            window.clearTimeout(timeoutId);
        };
    }, [codigoAluno, listAluno]);

    useEffect(() => {
        let active = true;

        if (!codigoAlunoEdicao) {
            setNomeFormandoEdicao("");
            setBuscandoNomeFormandoEdicao(false);
            return;
        }

        const timeoutId = window.setTimeout(async () => {
            setBuscandoNomeFormandoEdicao(true);
            const nome = await buscarNomeFormandoPorCodigo(codigoAlunoEdicao);
            if (active) {
                setNomeFormandoEdicao(nome);
                setBuscandoNomeFormandoEdicao(false);
            }
        }, 150);

        return () => {
            active = false;
            window.clearTimeout(timeoutId);
        };
    }, [codigoAlunoEdicao, listAluno]);

    const onChangePaginationCommon = async (e: any, value: any) => {
        await getRelatorioVendaPaged(value, dataSearch.RelatorioId, objUserTk.EmpresaId, dataSearch.ContratoId, 15, dataSearch.Status, dataSearch.InitialDate, dataSearch.FinalDate);
    };

    const onChangeAlunoPaginationCommon = async (e: any, value: number) => {
        if (!newRelatorioVenda.contratoId) return;
        await getAlunoPaged(value, newRelatorioVenda.contratoId, 10, alunoSearch.name, Number(alunoSearch.alunoId));
    };

    const onChangeAlunoPaginationEditar = async (e: any, value: number) => {
        if (editingRelatorioVenda?.contratoId) {
            await getAlunoPaged(value, editingRelatorioVenda.contratoId, 10, alunoSearch.name, Number(alunoSearch.alunoId));
        }
    };

    const onChangeAlunoVendedorPagination = async (e: any, value: number) => {
        if (editingRelatorioVenda?.id) {
            await getAlunosVendedoresPaged(editingRelatorioVenda.id, value, 10, alunoVendedorSearch.name, Number(alunoVendedorSearch.alunoId));
        }
    };

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataSearch({ ...dataSearch, [e.target.name]: e.target.value });
    };

    // Debounce automático para busca nos filtros principais do Relatório de Vendas
    useEffect(() => {
        if (!objUserTk?.EmpresaId) return;

        const hasFilters = dataSearch.RelatorioId !== 0 || dataSearch.ContratoId !== 0 || dataSearch.Status !== 0 || Boolean(dataSearch.InitialDate) || Boolean(dataSearch.FinalDate);
        if (isFirstMountRelatorios.current) {
            isFirstMountRelatorios.current = false;
            // Se não houver filtro na montagem, a carga inicial já foi acionada
            if (!hasFilters) return;
        }

        const timer = setTimeout(() => {
            setPageNumber(1);
            getRelatorioVendaPaged(
                1,
                dataSearch.RelatorioId,
                objUserTk.EmpresaId,
                dataSearch.ContratoId,
                15,
                dataSearch.Status,
                dataSearch.InitialDate,
                dataSearch.FinalDate,
                false
            );
        }, 400);

        return () => clearTimeout(timer);
    }, [dataSearch.RelatorioId, dataSearch.ContratoId, dataSearch.Status, dataSearch.InitialDate, dataSearch.FinalDate]);

    // Debounce automático para busca de formandos vinculados dentro do relatório aberto para edição
    useEffect(() => {
        if (!editingRelatorioVenda?.id) return;

        const timer = setTimeout(() => {
            getAlunosVendedoresPaged(
                editingRelatorioVenda.id,
                1,
                10,
                alunoVendedorSearch.name || undefined,
                alunoVendedorSearch.alunoId ? Number(alunoVendedorSearch.alunoId) : undefined
            );
        }, 400);

        return () => clearTimeout(timer);
    }, [editingRelatorioVenda?.id, alunoVendedorSearch.name, alunoVendedorSearch.alunoId]);

    const handleClearFilters = () => {
        setDataSearch({ RelatorioId: 0, ContratoId: 0, Status: 0, InitialDate: "", FinalDate: "" });
        setTipoFiltro("relatorioId");
        setTermoBusca("");
        setPageNumber(1);
        setLoading(true);
        getRelatorioVendaPaged(1, 0, objUserTk?.EmpresaId, 0, 15, undefined, undefined, undefined, false)
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    };

    const handleSearchSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
        if (e && e.preventDefault) e.preventDefault();
        setPageNumber(1);
        setLoading(true);
        getRelatorioVendaPaged(1, dataSearch.RelatorioId, objUserTk?.EmpresaId, dataSearch.ContratoId, 15, dataSearch.Status, dataSearch.InitialDate, dataSearch.FinalDate, false)
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    };

    const handleTipoFiltroChange = (novoTipo: string) => {
        setTipoFiltro(novoTipo);
        setTermoBusca("");
        setDataSearch({
            RelatorioId: 0,
            ContratoId: 0,
            Status: 0,
            InitialDate: "",
            FinalDate: ""
        });
    };

    const handleTermoBuscaChange = (valor: string) => {
        setTermoBusca(valor);
        if (tipoFiltro === "relatorioId") {
            setDataSearch(prev => ({ ...prev, RelatorioId: Number(valor) || 0, ContratoId: 0, Status: 0 }));
        } else if (tipoFiltro === "contratoId") {
            setDataSearch(prev => ({ ...prev, ContratoId: Number(valor) || 0, RelatorioId: 0, Status: 0 }));
        } else if (tipoFiltro === "status") {
            setDataSearch(prev => ({ ...prev, Status: Number(valor) || 0, RelatorioId: 0, ContratoId: 0 }));
        }
    };

    const handleAlunoSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!newRelatorioVenda.contratoId) return;

        setLoading(true);
        getAlunoPaged(1, newRelatorioVenda.contratoId, 10, alunoSearch.name, alunoSearch.alunoId ? Number(alunoSearch.alunoId) : undefined)
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    };

    const handleAlunoSearchSubmitEditar = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!editingRelatorioVenda?.contratoId) return;

        setLoading(true);
        getAlunoPaged(1, editingRelatorioVenda.contratoId, 10, alunoSearch.name, alunoSearch.alunoId ? Number(alunoSearch.alunoId) : undefined)
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    };

    const handleAlunoVendedorSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!editingRelatorioVenda?.id) return;

        setLoading(true);
        getAlunosVendedoresPaged(editingRelatorioVenda.id, 1, 10, alunoVendedorSearch.name, alunoVendedorSearch.alunoId ? Number(alunoVendedorSearch.alunoId) : undefined)
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    }

    //--------------------------------------------

    const formatRelatorioVendaData = (relatorioVenda: any) => ({
        ...relatorioVenda,
        id: Number(relatorioVenda.id),
        date: relatorioVenda.date ? relatorioVenda.date : null,
        status: relatorioVenda.status ? Number(relatorioVenda.status) : 1,
        checked: Boolean(relatorioVenda.checked),
        dateChecked: relatorioVenda.dateChecked ? relatorioVenda.dateChecked : null,
        empresaId: objUserTk?.EmpresaId || 0,
        contratoId: modoRelatorio === 'porContrato' && relatorioVenda.contratoId
            ? Number(relatorioVenda.contratoId)
            : undefined,
        relacoesAlunoVendedor: relacoesAlunoVendedor
    });

    const handleCreateInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            setNewRelatorioVenda(prevRelatorioVenda => ({
                ...prevRelatorioVenda,
                [name]: checked,
            }));
        } else {
            setNewRelatorioVenda(prevRelatorioVenda => ({
                ...prevRelatorioVenda,
                [name]: value,
            }));
        }
    };

    const handleCreateRelatorioVenda = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const formattedData = formatRelatorioVendaData(newRelatorioVenda);

        createRelatorioVenda(formattedData)
            .then(createdRelatorioVenda => {
                if (createdRelatorioVenda) {
                    setCreateModalOpen(false);
                    setListAluno([]);
                    setRelacoesAlunoVendedor([]);
                    setAlunosPendentesInfo({});
                    setVendedorAtivo(0);
                    setModoRelatorio('porContrato');
                    setBuscaCodigoAluno("");
                    setNewRelatorioVenda({
                        id: 0,
                        date: "",
                        status: 0,
                        checked: false,
                        dateChecked: "",
                        empresaId: 0,
                        contratoId: 0,
                    });
                    reloadRelatorios(1);
                } else {
                    console.error("Erro ao criar relatório.");
                }
            })
            .catch(error => {
                console.error("Erro ao criar relatório:", error);
            });
    };


    const handleEditInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;;
        setEditingRelatorioVenda(prevRelatorioVenda => ({
            ...prevRelatorioVenda!,
            [name]: type === 'checkbox' ? checked : value,
        }));
    }

    const handleEditRelatorioVenda = async (relatorioVenda: RelatorioVendaType) => {
        const updateData: EditRelatorioVendaType = {
            ...relatorioVenda,
            id: Number(relatorioVenda.id),
            date: relatorioVenda.date,
            status: relatorioVenda.status ? Number(relatorioVenda.status) : undefined,
            checked: Boolean(relatorioVenda.checked),
            dateChecked: relatorioVenda.dateChecked,
            empresaId: objUserTk?.EmpresaId || 0,
            contratoId: relatorioVenda.contratoId ? Number(relatorioVenda.contratoId) : undefined,
        };
        setEditingRelatorioVenda(updateData);

        await getAlunosVendedoresPaged(relatorioVenda.id, 1, 10);

        const todosVinculados = await getAlunosVendedoresByRelatorioId(relatorioVenda.id);
        setAlunosVinculados(todosVinculados || []);

        if (relatorioVenda.contratoId) {
            setAlunoPageCount(1);
            await getAlunoPaged(1, relatorioVenda.contratoId, 10);
        } else {
            setListAluno([]);
        }

        setRelacoesAlunoVendedor([]);
        setAlunosPendentesInfo({});
        setCodigoAlunoEdicao(0);
        setNomeFormandoEdicao("");
        setBuscandoNomeFormandoEdicao(false);
        setNumeroFotosEdicao(0);
        setVendedorAtivoEdicao(0);
        setNovoVendedorRelatorio(0);
        setNovoVendedorLote(0);
        setAlunosSelecionadosIds([]);
        setStatusEmEdicaoPorAluno({});
        setEditModalOpen(true);
    };

    const handleEditSubmit = () => {
        if (editingRelatorioVenda) {

            const updatedData: EditRelatorioVendaType = {
                ...editingRelatorioVenda,
            };

            updateRelatorioVenda(updatedData)
                .then(updatedRelatorioVenda => {
                    if (updatedRelatorioVenda) {
                        setEditModalOpen(false);
                        reloadRelatorios(pageNumber);
                    } else {
                        console.error("Erro ao atualizar relatório.");
                    }
                })
                .catch(error => {
                    console.error("Erro ao atualizar relatório:", error);
                });
        }
    };

    const handleEditRelacaoInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;;
        setEditingRelacaoRelatorioVenda(prevRelacaoRelatorioVenda => ({
            ...prevRelacaoRelatorioVenda!,
            [name]: type === 'checkbox' ? checked : value,
        }));
    }

    const handleEditRelacaoRelatorioVenda = async (relacaoRelatorioVenda: AlunoVendedorType) => {
        const updateData: EditRelacaoRelatorioVendaType = {
            ...relacaoRelatorioVenda,
            id: Number(relacaoRelatorioVenda.id),
            numberPhotos: relacaoRelatorioVenda.numberPhotos,
            status: relacaoRelatorioVenda.status ? Number(relacaoRelatorioVenda.status) : 0,
            vendedorId: relacaoRelatorioVenda.vendedorId ? Number(relacaoRelatorioVenda.vendedorId) : undefined,
            permissaoVendaRestricao: !!relacaoRelatorioVenda.permissaoVendaRestricao,
        };
        setEditingRelacaoRelatorioVenda(updateData);

        if (editingRelatorioVenda) {
            await getAlunosVendedoresByRelatorioId(editingRelatorioVenda.id);
        }

        setEditRelacaoModalOpen(true);
    };

    const handleRelacaoEditSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (editingRelacaoRelatorioVenda) {

            const updatedData: EditRelacaoRelatorioVendaType = {
                ...editingRelacaoRelatorioVenda,
            };

            updateRelacoesRelatorioVenda(updatedData)
                .then(async updatedRelacaoRelatorioVenda => {
                    if (updatedRelacaoRelatorioVenda) {
                        if (editingRelatorioVenda) {
                            getAlunosVendedoresPaged(editingRelatorioVenda.id, 1, 10);
                            const atualizados = await getAlunosVendedoresByRelatorioId(editingRelatorioVenda.id);
                            setAlunosVinculados(atualizados || []);
                        }
                        setEditRelacaoModalOpen(false);
                    } else {
                        console.error("Erro ao atualizar relação.");
                    }
                })
                .catch(error => {
                    console.error("Erro ao atualizar relação:", error);
                });
        }
    };

    const [confirmDeleteRelatorioVendaId, setConfirmDeleteRelatorioVendaId] = useState<number | null>(null);

    const handleDeleteRelatorioVenda = (relatorioVendaId: number) => {
        setConfirmDeleteRelatorioVendaId(relatorioVendaId);
    };

    const executeDeleteRelatorioVenda = () => {
        if (confirmDeleteRelatorioVendaId == null) return;
        deleteRelatorioVenda(confirmDeleteRelatorioVendaId)
            .then(() => {
                setTimeout(() => {
                    reloadRelatorios(1);
                }, 500);
            })
            .catch(error => console.error("Erro ao excluir relatório:", error));
        setConfirmDeleteRelatorioVendaId(null);
    };

    const adicionarAlunoManual = async (e: any) => {
        if (e && e.preventDefault) e.preventDefault();
        if (isAddingAluno) return;

        if (!codigoAluno || !numeroFotos || vendedorAtivo === 0) {
            alert("Preencha código do aluno, número de fotos e selecione um vendedor.");
            return;
        }

        setIsAddingAluno(true);
        try {
            // const aluno = await handleGetAlunoById(codigoAluno);
            const aluno = await handleGetAlunoByReferenceCode(codigoAluno);
            if (!aluno) {
                alert("Aluno não encontrado.");
                return;
            }

            if (modoRelatorio === 'porContrato') {
                const pertenceAoContrato = await validarAlunoPertenceAoContrato(aluno.id, newRelatorioVenda.contratoId!);
                if (!pertenceAoContrato) {
                    Swal.fire("Erro", "Este aluno não está vinculado ao contrato selecionado e não pode ser adicionado.", "error");
                    return;
                }
            }

            const jaExiste = relacoesAlunoVendedor.find((a) => a.alunoId === aluno.id);
            if (jaExiste) {
                Swal.fire("Atenção", "Este aluno já foi adicionado.", "warning");
                return;
            }

            const novaRelacao: CreateRelacaoRelatorioVendaType = {
                alunoId: aluno.id,
                vendedorId: vendedorAtivo,
                numberPhotos: numeroFotos,
                status: 1,
            };

            setRelacoesAlunoVendedor((prev) => {
                if (prev.some((a) => a.alunoId === aluno.id)) return prev;
                return [...prev, novaRelacao];
            });
            setAlunosPendentesInfo((prev) => ({
                ...prev,
                [aluno.id]: { referenceCode: aluno.referenceCode, name: aluno.name }
            }));
            setCodigoAluno(0);
            setNomeFormando("");
            setBuscandoNomeFormando(false);
            setNumeroFotos(0);
            setTimeout(() => document.getElementById("codigoAlunoInput")?.focus(), 100);
        } catch (error) {
            console.error("Erro ao adicionar aluno:", error);
        } finally {
            setIsAddingAluno(false);
        }
    };

    const adicionarAlunoManualEdicao = async (e: any) => {
        if (e && e.preventDefault) e.preventDefault();
        if (isAddingAlunoEdicao) return;

        if (!codigoAlunoEdicao || !numeroFotosEdicao || vendedorAtivoEdicao === 0) {
            alert("Preencha código do aluno, número de fotos e selecione um vendedor.");
            return;
        }

        setIsAddingAlunoEdicao(true);
        try {
            const aluno = await handleGetAlunoByReferenceCode(codigoAlunoEdicao);
            if (!aluno) {
                alert("Aluno não encontrado.");
                return;
            }

            if (editingRelatorioVenda?.contratoId) {
                const pertenceAoContrato = await validarAlunoPertenceAoContrato(aluno.id, editingRelatorioVenda.contratoId);
                if (!pertenceAoContrato) {
                    Swal.fire("Erro", "Este aluno não pertence ao contrato deste relatório e não pode ser adicionado.", "error");
                    return;
                }
            }

            const jaVinculado = alunosVinculados.find((a) => a.alunoId === aluno.id);
            if (jaVinculado) {
                const resultado = await Swal.fire({
                    title: "Aluno já vinculado",
                    text: `O aluno ${aluno.name} já está neste relatório com o vendedor ${jaVinculado.vendedorNome}. Deseja adicionar mesmo assim?`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Sim, adicionar",
                    cancelButtonText: "Não, cancelar",
                });

                if (!resultado.isConfirmed) return;
            }

            const novaRelacao: CreateRelacaoRelatorioVendaType = {
                alunoId: aluno.id,
                vendedorId: vendedorAtivoEdicao,
                numberPhotos: numeroFotosEdicao,
                status: 1,
            };

            if (editingRelatorioVenda) {
                const result = await adicionarRelacoesAoRelatorio(editingRelatorioVenda.id, [novaRelacao]);
                if (result) {
                    // Limpa os campos e dá foco imediatamente para o usuário digitar o próximo formando sem espera
                    setCodigoAlunoEdicao(0);
                    setNomeFormandoEdicao("");
                    setBuscandoNomeFormandoEdicao(false);
                    setNumeroFotosEdicao(0);
                    setTimeout(() => document.getElementById("codigoAlunoInputEdicao")?.focus(), 50);

                    // Atualiza a listagem sem bloquear a digitação do operador
                    setAlunoVendedorSearch({ name: "", alunoId: "" });
                    setAlunosSelecionadosIds([]);
                    Promise.all([
                        getAlunosVendedoresPaged(editingRelatorioVenda.id, 1, 10),
                        getAlunosVendedoresByRelatorioId(editingRelatorioVenda.id)
                    ]).then(([paged, updated]) => {
                        if (updated) {
                            setAlunosVinculados(updated);
                        }
                    }).catch(err => {
                        console.error("Erro ao sincronizar alunos em background:", err);
                    });
                }
            }
        } catch (error) {
            console.error("Erro ao adicionar aluno ao relatório:", error);
        } finally {
            setIsAddingAlunoEdicao(false);
        }
    };

    const toggleAlunoSelecionado = (alunoId: number) => {
        setAlunosSelecionadosIds((prevSelecionados) =>
            prevSelecionados.includes(alunoId)
                ? prevSelecionados.filter(id => id !== alunoId)
                : [...prevSelecionados, alunoId]
        );
    };

    const handleChangeStatusIndividual = (relacaoId: number, status: number) => {
        setStatusEmEdicaoPorAluno(prev => ({
            ...prev,
            [relacaoId]: status
        }));
    };

    const handleSalvarTodosStatus = async () => {
        if (!editingRelatorioVenda) return;
        const relacoesAlteradas = Object.entries(statusEmEdicaoPorAluno);
        if (relacoesAlteradas.length === 0) {
            Swal.fire("Atenção", "Nenhum status foi modificado para salvar.", "info");
            return;
        }

        const confirmacao = await Swal.fire({
            title: "Confirmar baixa / atualização dos status?",
            text: `Deseja aplicar e salvar as alterações de status para os ${relacoesAlteradas.length} formando(s) modificado(s)?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Sim, confirmar todos",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#2dce89",
        });

        if (!confirmacao.isConfirmed) return;

        setSalvandoStatusIndividual(true);
        try {
            // Executa a atualização de cada relação modificada
            const promises = relacoesAlteradas.map(async ([relacaoIdStr, novoStatus]) => {
                const relId = Number(relacaoIdStr);
                const relacaoAtual = listRelacaoAlunosVendedores.find(r => r.id === relId);
                const updatePayload: EditRelacaoRelatorioVendaType = {
                    id: relId,
                    numberPhotos: relacaoAtual ? relacaoAtual.numberPhotos : 0,
                    status: novoStatus,
                    vendedorId: relacaoAtual ? relacaoAtual.vendedorId : undefined
                };
                return updateRelacoesRelatorioVenda(updatePayload);
            });

            await Promise.all(promises);

            Swal.fire("Sucesso!", "Todos os status foram atualizados com sucesso.", "success");
            setStatusEmEdicaoPorAluno({});
            await getAlunosVendedoresPaged(editingRelatorioVenda.id, 1, 10);
            const atualizados = await getAlunosVendedoresByRelatorioId(editingRelatorioVenda.id);
            setAlunosVinculados(atualizados || []);
            reloadRelatorios(pageNumber);
        } catch (error) {
            console.error("Erro ao salvar status em lote:", error);
            Swal.fire("Erro", "Ocorreu um erro ao atualizar os status dos formandos.", "error");
        } finally {
            setSalvandoStatusIndividual(false);
        }
    };

    const aplicarNovoStatusLote = () => {
        if (!editingRelatorioVenda || novoStatusLote === 0 || alunosSelecionadosIds.length === 0) {
            Swal.fire("Atenção", "Selecione pelo menos um formando e um status válido.", "warning");
            return;
        }

        // Mapeia os formandos selecionados para o status escolhido no buffer local
        setStatusEmEdicaoPorAluno(prev => {
            const next = { ...prev };
            listRelacaoAlunosVendedores.forEach(item => {
                if (alunosSelecionadosIds.includes(item.alunoId)) {
                    next[item.id] = novoStatusLote;
                }
            });
            return next;
        });

        const totalSelecionados = alunosSelecionadosIds.length;
        setAlunosSelecionadosIds([]);
        setNovoStatusLote(0);

        Swal.fire({
            title: "Status atribuído!",
            text: `Status aplicado para ${totalSelecionados} formando(s). Você pode alterar outros ou clicar em 'Confirmar Baixa / Salvar Todos' para finalizar.`,
            icon: "success",
            timer: 2000,
            showConfirmButton: false
        });
    };

    const handleAlterarVendedorRelatorio = async () => {
        if (!editingRelatorioVenda || novoVendedorRelatorio === 0) {
            Swal.fire("Atenção", "Selecione o novo vendedor para o relatório.", "warning");
            return;
        }

        const vendedorDestino = listVendedores.find(v => v.id === novoVendedorRelatorio);
        const vendedorNome = vendedorDestino ? vendedorDestino.name : `#${novoVendedorRelatorio}`;

        const confirmacao = await Swal.fire({
            title: "Alterar vendedor do relatório?",
            text: `Todos os lançamentos deste relatório serão transferidos para o vendedor ${vendedorNome}. Deseja continuar?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Sim, alterar todos",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#5e72e4",
        });

        if (!confirmacao.isConfirmed) return;

        const sucesso = await alterarVendedorRelatorio(editingRelatorioVenda.id, {
            novoVendedorId: novoVendedorRelatorio
        });

        if (sucesso) {
            setNovoVendedorRelatorio(0);
            const atualizados = await getAlunosVendedoresByRelatorioId(editingRelatorioVenda.id);
            setAlunosVinculados(atualizados || []);
            await getAlunosVendedoresPaged(editingRelatorioVenda.id, 1, 10);
            setAlunosSelecionadosIds([]);
            // Atualiza a listagem geral dos relatórios em segundo plano
            getRelatorioVendaPaged(pageNumber, dataSearch.RelatorioId, objUserTk?.EmpresaId, dataSearch.ContratoId, 15, dataSearch.Status, dataSearch.InitialDate, dataSearch.FinalDate, false);
        }
    };

    const aplicarNovoVendedorLote = async () => {
        if (!editingRelatorioVenda || novoVendedorLote === 0 || alunosSelecionadosIds.length === 0) {
            Swal.fire("Atenção", "Selecione pelo menos um formando e o novo vendedor.", "warning");
            return;
        }

        const vendedorDestino = listVendedores.find(v => v.id === novoVendedorLote);
        const vendedorNome = vendedorDestino ? vendedorDestino.name : `#${novoVendedorLote}`;

        const confirmacao = await Swal.fire({
            title: "Alterar vendedor dos selecionados?",
            text: `O vendedor dos ${alunosSelecionadosIds.length} formando(s) selecionado(s) será alterado para ${vendedorNome}. Deseja continuar?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Sim, alterar",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#5e72e4",
        });

        if (!confirmacao.isConfirmed) return;

        const sucesso = await alterarVendedorRelatorio(editingRelatorioVenda.id, {
            novoVendedorId: novoVendedorLote,
            alunoIds: alunosSelecionadosIds
        });

        if (sucesso) {
            setNovoVendedorLote(0);
            setAlunosSelecionadosIds([]);
            const atualizados = await getAlunosVendedoresByRelatorioId(editingRelatorioVenda.id);
            setAlunosVinculados(atualizados || []);
            await getAlunosVendedoresPaged(editingRelatorioVenda.id, 1, 10);
            getRelatorioVendaPaged(pageNumber, dataSearch.RelatorioId, objUserTk?.EmpresaId, dataSearch.ContratoId, 15, dataSearch.Status, dataSearch.InitialDate, dataSearch.FinalDate, false);
        }
    };

    const toggleSelecionarTodos = () => {
        if (todosSelecionados) {
            setAlunosSelecionadosIds([]);
        } else {
            const todosIds = listRelacaoAlunosVendedores.map((a) => a.alunoId);
            setAlunosSelecionadosIds(todosIds);
        }
        setTodosSelecionados(!todosSelecionados);
    };

    useEffect(() => {
        const todosIds = listRelacaoAlunosVendedores.map((a) => a.alunoId);
        setTodosSelecionados(
            todosIds.length > 0 && todosIds.every((id) => alunosSelecionadosIds.includes(id))
        );
    }, [alunosSelecionadosIds, listRelacaoAlunosVendedores]);

    const getStatusLabel = (status: number) => {
        switch (status) {
            case 1:
                return "Ativo";
            case 2:
                return "Baixado";
            default:
                return "Desconhecido";
        }
    };

    const getRelacaoStatusLabel = (status: number) => {
        switch (status) {
            case 1:
                return "Em rota";
            case 2:
                return "Roteiro";
            case 3:
                return "Retorno";
            case 4:
                return "Devolvido";
            case 5:
                return "Vendido";
            case 6:
                return "Descartado";
            case 7:
                return "Recusou Album";
            default:
                return "Desconhecido";
        }
    }

    const getStatusRowColor = (status: number): string => {
        switch (status) {
            case 2: return '#d1ecf1';
            case 3: return '#e8edd4';
            case 4: return '#fff3cd';
            case 5: return '#d4edda';
            case 6: return '#f8d7da';
            default: return '';
        }
    };

    const handleContratoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const contratoId = Number(e.target.value);

        setNewRelatorioVenda(prev => ({
            ...prev,
            contratoId: contratoId
        }));

        if (contratoId > 0) {
            getAlunoPaged(1, contratoId, 10);
        } else {
            setListAluno([]);
        }
    };

    function resetCampos() {
        setModoRelatorio('porContrato');
        setBuscaCodigoAluno("");
        setNewRelatorioVenda({
            id: 0,
            date: "",
            status: 0,
            checked: false,
            dateChecked: "",
            empresaId: 0,
            contratoId: 0,
        });
        setEditingRelatorioVenda(null);
        setListAluno([]);
        setRelacoesAlunoVendedor([]);
        setAlunosPendentesInfo({});
        setVendedorAtivo(0);
        setCodigoAluno(0);
        setNomeFormando("");
        setNomeFormandoEdicao("");
        setBuscandoNomeFormando(false);
        setBuscandoNomeFormandoEdicao(false);
        setNumeroFotos(0);
    }

    const vendedoresVinculadosUnicos = Array.from(
        new Map(
            alunosVinculados.map(v => [v.vendedorId, { id: v.vendedorId, nome: v.vendedorNome }])
        ).values()
    );

    const contratoOptions = listContrato.map(contrato => ({
        value: contrato.id,
        label: `${contrato.id} - ${contrato.description}`
    }));

    const vendedorOptions = listVendedores.map(v => ({
        value: v.id,
        label: v.name
    }));

    const selectedVendedor = vendedorOptions.find(v => v.value === vendedorAtivoEdicao) || null;

    if (loaging) {
        return <LoadingSpinner />;
    }

    const toggleRelatorioSelecionado = (relatorioId: number) => {
        setRelatoriosSelecionadosIds((prev) =>
            prev.includes(relatorioId)
                ? prev.filter((id) => id !== relatorioId)
                : [...prev, relatorioId]
        );
    };

    const formatDateShort = (dateStr?: string | null) => {
        if (!dateStr || dateStr === "Data ainda não definida") return "-";
        if (dateStr.includes("-")) {
            const parts = dateStr.split("T")[0].split("-");
            if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
        }
        return dateStr;
    };

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar
                brandText={"Gerenciar relatórios de venda"}
                search={false}
                titleSearch={""}
            />

            <style>{`
                .main-content {
                    overflow-x: hidden !important;
                }
                .main-content .container-fluid.full-screen-container {
                    padding-left: 15px !important;
                    padding-right: 15px !important;
                    max-width: 100% !important;
                    overflow-x: hidden !important;
                }
            `}</style>
            <Container fluid className="mt-2 px-3 full-screen-container">
                <div className="card shadow-sm border-0 mb-3 p-3 w-100">
                    <Form onSubmit={handleSearchSubmit}>
                        <Row className="align-items-end mb-2">
                            <Col xs="12" sm="4" md="3" lg="3" className="mb-3">
                                <Label className="form-control-label font-weight-bold" for="tipoFiltro">Filtrar por</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="select"
                                    id="tipoFiltro"
                                    value={tipoFiltro}
                                    onChange={(e) => handleTipoFiltroChange(e.target.value)}
                                >
                                    <option value="relatorioId">Número do Relatório</option>
                                    <option value="contratoId">Nº Contrato</option>
                                    <option value="status">Status</option>
                                </Input>
                            </Col>

                            <Col xs="12" sm="8" md="5" lg="5" className="mb-3">
                                <Label className="form-control-label font-weight-bold" for="termoBusca">
                                    {tipoFiltro === "relatorioId"
                                        ? "Número do Relatório"
                                        : tipoFiltro === "contratoId"
                                        ? "Número do Contrato"
                                        : "Status"}
                                </Label>
                                {tipoFiltro === "status" ? (
                                    <Input
                                        className="form-control-alternative"
                                        type="select"
                                        id="termoBusca"
                                        value={dataSearch.Status}
                                        onChange={(e) => handleTermoBuscaChange(e.target.value)}
                                    >
                                        <option value={0}>Selecione um Status</option>
                                        <option value={1}>Ativo</option>
                                        <option value={2}>Baixado</option>
                                    </Input>
                                ) : (
                                    <Input
                                        className="form-control-alternative"
                                        type="number"
                                        id="termoBusca"
                                        placeholder={
                                            tipoFiltro === "relatorioId"
                                                ? "Digite o número do relatório..."
                                                : "Digite o número do contrato..."
                                        }
                                        value={termoBusca}
                                        onChange={(e) => handleTermoBuscaChange(e.target.value)}
                                    />
                                )}
                            </Col>

                            <Col xs="12" md="4" lg="4" className="d-flex justify-content-start justify-content-md-end mb-3 align-items-end" style={{ gap: '8px' }}>
                                <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit" size="m">
                                    <i className="fa-solid fa-magnifying-glass mr-1"></i> Buscar
                                </Button>
                                <Button
                                    style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                                    type="button"
                                    size="m"
                                    onClick={handleClearFilters}
                                >
                                    <i className="fa-solid fa-trash-can mr-1"></i> Limpar
                                </Button>
                            </Col>
                        </Row>

                        <Row className="align-items-center pt-2 border-top">
                            <Col xs="12" sm="6" md="3" lg="3" className="mb-2">
                                <Label className="form-control-label font-weight-bold small text-muted" for="InitialDate">Período - Data Inicial (opcional)</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="date"
                                    name="InitialDate"
                                    id="InitialDate"
                                    value={dataSearch.InitialDate}
                                    onChange={handleSearchChange}
                                />
                            </Col>
                            <Col xs="12" sm="6" md="3" lg="3" className="mb-2">
                                <Label className="form-control-label font-weight-bold small text-muted" for="FinalDate">Período - Data Final (opcional)</Label>
                                <Input
                                    className="form-control-alternative"
                                    type="date"
                                    name="FinalDate"
                                    id="FinalDate"
                                    value={dataSearch.FinalDate}
                                    onChange={handleSearchChange}
                                />
                            </Col>
                        </Row>
                        {hasPermission(PermissionModule.RelatorioVendas, 1) && (
                            <Row>
                                <Col xs="12" className="d-flex flex-wrap justify-content-end align-items-center mt-3" style={{ gap: '8px' }}>
                                    <Button
                                        color="success"
                                        disabled={relatoriosSelecionadosIds.length === 0}
                                        onClick={() => downloadRelatorioMultiplosPdf(objUserTk.EmpresaId, relatoriosSelecionadosIds)}
                                    >
                                        <i className="fa-solid fa-file-pdf mr-2"></i> Exportar Múltiplas Vendas
                                    </Button>
                                    <Button
                                        style={{ backgroundColor: '#007bff', color: '#FFF' }}
                                        onClick={() => {
                                            setVendedorFiltroExport(0);
                                            setStatusFiltroExport(0);
                                            setInitialDateFiltroExport(dataSearch.InitialDate);
                                            setFinalDateFiltroExport(dataSearch.FinalDate);
                                            setExportModalOpen(true);
                                        }}
                                    >
                                        <i className="fa-solid fa-file-pdf mr-2"></i> Exportar Vendas Ativas
                                    </Button>
                                    <Button
                                        style={{ color: "#FFF", backgroundColor: "#32325d" }}
                                        size="m"
                                        onClick={() => { setCreateModalOpen(true); resetCampos(); setAlunoSearch({ name: "", alunoId: "" }); }}
                                    >
                                        <i className="fa-solid fa-plus mr-1"></i> Adicionar relatório
                                    </Button>
                                </Col>
                            </Row>
                        )}
                    </Form>
                </div>

                {hasPermission(PermissionModule.RelatorioVendas, 2) ? (
                    <div className="card shadow-sm border-0 mb-3 p-2 w-100" style={{ overflowX: 'auto' }}>
                        <Table hover size="sm" className="table-striped align-items-center mb-0" style={{ width: '100%', fontSize: '11.5px' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: '35px', textAlign: 'center', padding: '6px 4px' }}>
                                        <Input
                                            type="checkbox"
                                            style={{
                                                position: 'static',
                                                margin: 0
                                            }}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    const allIds = listRelatorioVenda.map(r => r.id);
                                                    setRelatoriosSelecionadosIds(allIds);
                                                } else {
                                                    setRelatoriosSelecionadosIds([]);
                                                }
                                            }}
                                            checked={listRelatorioVenda.length > 0 && relatoriosSelecionadosIds.length === listRelatorioVenda.length}
                                        />
                                    </th>
                                    <th style={{ width: '70px', textAlign: 'center', padding: '6px 4px' }}>Documento</th>
                                    <th style={{ width: '85px', textAlign: 'center', padding: '6px 4px' }}>Data</th>
                                    <th style={{ width: '80px', textAlign: 'center', padding: '6px 4px' }}>Contrato</th>
                                    <th style={{ maxWidth: '180px', padding: '6px 4px' }}>Vendedor</th>
                                    <th style={{ width: '70px', textAlign: 'center', padding: '6px 4px' }}>Status</th>
                                    <th style={{ width: '65px', textAlign: 'center', padding: '6px 4px' }}>Conferido</th>
                                    <th style={{ width: '85px', textAlign: 'center', padding: '6px 4px' }}>Data Conferido</th>
                                    <th style={{ width: '100px', textAlign: 'center', padding: '6px 4px' }}>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {listRelatorioVenda.map(item => (
                                    <tr key={item.id} style={item.status === 2 ? { backgroundColor: "#e8f7e4" } : undefined}>
                                        <td style={{ textAlign: 'center', padding: '4px' }}>
                                            <Input
                                                type="checkbox"
                                                style={{
                                                    position: 'static',
                                                    margin: 0
                                                }}
                                                checked={relatoriosSelecionadosIds.includes(item.id)}
                                                onChange={() => toggleRelatorioSelecionado(item.id)}
                                            />
                                        </td>
                                        <td className="font-weight-bold" style={{ textAlign: 'center', padding: '4px' }}>{item.id}</td>
                                        <td style={{ textAlign: 'center', padding: '4px' }}>{item.date ? item.date.split('-').reverse().join('/') : "-"}</td>
                                        <td style={{ textAlign: 'center', padding: '4px' }}>{item.contratoId || <span style={{ color: '#888', fontStyle: 'italic' }}>Por aluno</span>}</td>
                                        <td style={{ maxWidth: '180px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', padding: '4px' }} title={item.vendedorNome || ""}>
                                            {item.vendedorNome || <span style={{ color: '#888', fontStyle: 'italic' }}>-</span>}
                                        </td>
                                        <td style={{ textAlign: 'center', padding: '4px' }}>{getStatusLabel(Number(item.status))}</td>
                                        <td style={{ textAlign: 'center', padding: '4px' }}>{item.checked ? "Sim" : "Não"}</td>
                                        <td style={{ textAlign: 'center', padding: '4px' }}>{formatDateShort(item.dateChecked)}</td>
                                        <td style={{ textAlign: 'center', whiteSpace: 'nowrap', padding: '4px' }}>
                                            <Button
                                                title="Pré-visualizar e Imprimir"
                                                color="info"
                                                size="sm"
                                                className="btn-sm p-1 mx-1"
                                                onClick={() => handlePreviewRelatorio(item.id)}
                                            >
                                                <i className="fa-solid fa-print"></i>
                                            </Button>
                                            <Button
                                                title="Editar"
                                                size="sm"
                                                color="primary"
                                                className="btn-sm p-1 mx-1"
                                                onClick={() => { handleEditRelatorioVenda(item); setAlunoSearch({ name: "", alunoId: "" }); }}
                                            >
                                                <i className="fa-solid fa-pen-to-square"></i>
                                            </Button>
                                            <Button
                                                title="Excluir"
                                                size="sm"
                                                className="btn-sm p-1 mx-1"
                                                onClick={() => handleDeleteRelatorioVenda(item.id)}
                                                color="danger"
                                            >
                                                <i className="fa-solid fa-trash"></i>
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <div className="mt-3">
                                {listRelatorioVenda.length === 0 && (
                                    <div style={{ color: "red", textAlign: "center" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                )}
                                <div ref={sentinelRef} style={{ height: '20px' }} />
                                {loadingMore && (
                                    <div className="d-flex justify-content-center align-items-center py-3">
                                        <Spinner size="sm" color="primary" className="mr-2" />
                                        <span className="text-muted small font-weight-bold">Carregando mais relatórios...</span>
                                    </div>
                                )}
                                {listRelatorioVenda.length > 0 && pageNumber >= relatorioVendaPageCount && (
                                    <div className="text-center text-muted small py-2">
                                        Todos os relatórios foram carregados ({listRelatorioVenda.length} registros exibidos).
                                    </div>
                                )}
                            </div>
                    </div>
                ) : (
                    <div className="card shadow-sm border-0 mb-4 p-4 text-center">
                        <div style={{ color: "red", textAlign: "center" }}>
                            Você não tem permissão para visualizar os relatórios de venda.
                        </div>
                    </div>
                )}
            </Container>

            <Modal isOpen={createModalOpen} toggle={() => {
                setCreateModalOpen(!createModalOpen);
            }} backdrop="static" size="xl">
                <ModalHeader toggle={() => setCreateModalOpen(!createModalOpen)}>Adicionar Relatório de Venda</ModalHeader>
                <ModalBody>
                    {/* Seleção de modo */}
                    <Row className="mb-3">
                        <Col>
                            <div className="d-flex" style={{ gap: 16 }}>
                                <Label check style={{ cursor: 'pointer', fontWeight: modoRelatorio === 'porContrato' ? 700 : 400 }}>
                                    <input
                                        type="radio"
                                        name="modoRelatorio"
                                        value="porContrato"
                                        checked={modoRelatorio === 'porContrato'}
                                        onChange={() => {
                                            setModoRelatorio('porContrato');
                                            setBuscaCodigoAluno("");
                                            setListAluno([]);
                                            setRelacoesAlunoVendedor([]);
                                        }}
                                        style={{ marginRight: 6 }}
                                    />
                                    Por Contrato
                                </Label>
                                <Label check style={{ cursor: 'pointer', fontWeight: modoRelatorio === 'porAluno' ? 700 : 400 }}>
                                    <input
                                        type="radio"
                                        name="modoRelatorio"
                                        value="porAluno"
                                        checked={modoRelatorio === 'porAluno'}
                                        onChange={() => {
                                            setModoRelatorio('porAluno');
                                            setNewRelatorioVenda(prev => ({ ...prev, contratoId: 0 }));
                                            setListAluno([]);
                                            setRelacoesAlunoVendedor([]);
                                            setBuscaCodigoAluno("");
                                        }}
                                        style={{ marginRight: 6 }}
                                    />
                                    Por Código
                                </Label>
                            </div>
                        </Col>
                    </Row>

                    <Form onSubmit={handleCreateRelatorioVenda}>
                        <Row>
                            <Col md="6">
                                {modoRelatorio === 'porContrato' ? (
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="contratoId">
                                            Contrato
                                        </Label>
                                        <Select
                                            className="form-control-alternative"
                                            options={contratoOptions}
                                            value={contratoOptions.find(opt => opt.value === newRelatorioVenda.contratoId)}
                                            onChange={(selectedOption) => {
                                                const contratoId = selectedOption?.value || 0;
                                                setNewRelatorioVenda(prev => ({ ...prev, contratoId: contratoId }));
                                                if (contratoId > 0) {
                                                    getAlunoPaged(1, contratoId, 10);
                                                } else {
                                                    setListAluno([]);
                                                }
                                            }}
                                            placeholder="Selecione ou pesquise um contrato..."
                                            isClearable
                                        />
                                    </FormGroup>
                                ) : (
                                    <FormGroup>
                                        <Label className="form-control-label">Buscar aluno por código</Label>
                                        <div className="d-flex" style={{ gap: 8 }}>
                                            <Input
                                                className="form-control-alternative"
                                                type="number"
                                                placeholder="Digite o código do aluno..."
                                                value={buscaCodigoAluno}
                                                onChange={(e) => setBuscaCodigoAluno(e.target.value)}
                                                onKeyDown={(e) => { if (e.key === 'Enter') e.preventDefault(); }}
                                            />
                                            <Button
                                                type="button"
                                                style={{ backgroundColor: '#585858', color: '#FFF', whiteSpace: 'nowrap' }}
                                                onClick={() => {
                                                    if (buscaCodigoAluno.trim()) {
                                                        getAlunoPaged(1, 0, 10, undefined, undefined, undefined, Number(buscaCodigoAluno.trim()), objUserTk.EmpresaId);
                                                    }
                                                }}
                                            >
                                                Buscar
                                            </Button>
                                        </div>
                                        <small className="text-muted">
                                            Os alunos encontrados aparecerão abaixo para adição ao relatório.
                                        </small>
                                    </FormGroup>
                                )}
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="date">
                                        Data de Saída para Venda
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="date"
                                        name="date"
                                        id="date"
                                        value={newRelatorioVenda.date?.toString() || ""}
                                        onChange={handleCreateInputChange}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="status">
                                        Status
                                    </Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="select"
                                        name="status"
                                        id="status"
                                        value={newRelatorioVenda.status}
                                        onChange={handleCreateInputChange}
                                    >
                                        <option value={0}>Selecione um Status</option>
                                        <option value={1}>Ativo</option>
                                        <option value={2}>Baixado</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="vendedorAtivo">
                                        Vendedor atual
                                    </Label>
                                    <Select
                                        className="form-control-alternative"
                                        options={vendedorOptions}
                                        value={vendedorOptions.find(opt => opt.value === vendedorAtivo)}
                                        onChange={(selectedOption) => setVendedorAtivo(selectedOption?.value || 0)}
                                        placeholder="Selecione ou digite para buscar..."
                                        isClearable
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="d-flex justify-content-end mt-3">
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#585858" }}
                                type="submit"
                                size="m"
                            >
                                Criar Relatório
                            </Button>
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                                className="ml-2"
                                onClick={() => { setCreateModalOpen(false); reloadRelatorios(1); }}
                                size="m"
                            >
                                Cancelar
                            </Button>
                        </div>
                    </Form>
                    {listAluno.length > 0 && (
                        <>
                            <hr />
                            <h4>{modoRelatorio === 'porAluno' ? 'Alunos encontrados' : 'Alunos vinculados ao contrato'}</h4>
                            <Form onSubmit={adicionarAlunoManual} className="mb-4">
                                <Row>
                                    <Col md="6">
                                        <Label className="form-control-label" htmlFor="codigoAlunoInput">Código do Aluno</Label>
                                        <Input
                                            id="codigoAlunoInput"
                                            className="form-control-alternative"
                                            type="number"
                                            placeholder="Digite o código do aluno"
                                            value={codigoAluno || ""}
                                            onChange={(e) => setCodigoAluno(Number(e.target.value))}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    e.preventDefault();
                                                    document.getElementById("inputFotos")?.focus();
                                                }
                                                if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                    e.preventDefault();
                                                }
                                            }}
                                            onWheel={(e) => e.currentTarget.blur()}
                                        />
                                    </Col>
                                    <Col md="6">
                                        <Label className="form-control-label" htmlFor="inputFotos">Número de Fotos</Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="number"
                                            id="inputFotos"
                                            value={numeroFotos || ""}
                                            onChange={(e) => setNumeroFotos(Number(e.target.value))}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    e.preventDefault();
                                                    adicionarAlunoManual(e);
                                                }
                                            }}
                                            disabled={!codigoAluno || isAddingAluno}
                                        />
                                    </Col>
                                </Row>
                                <Row className="mt-3 align-items-center">
                                    <Col md="6">
                                        <Input
                                            className="form-control-alternative"
                                            type="text"
                                            value={
                                                buscandoNomeFormando
                                                    ? "Nome do formando: Buscando..."
                                                    : nomeFormando
                                                    ? `Nome do formando: ${nomeFormando}`
                                                    : codigoAluno
                                                    ? "Nome do formando: Aluno não encontrado"
                                                    : "Nome do formando: Digite o código do aluno"
                                            }
                                            disabled
                                            style={{
                                                backgroundColor: "#e9ecef",
                                                color: "#495057",
                                                fontWeight: 500,
                                                cursor: "default"
                                            }}
                                        />
                                    </Col>
                                    <Col md="6" className="d-flex justify-content-end">
                                        <Button 
                                            style={{ color: "#FFF", backgroundColor: "#585858" }} 
                                            type="submit"
                                            disabled={isAddingAluno}
                                        >
                                            {isAddingAluno ? "Adicionando..." : "Adicionar"}
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                            {relacoesAlunoVendedor.length > 0 && (
                                <Table striped responsive className="table-striped">
                                    <thead>
                                        <tr>
                                            <th>Código</th>
                                            <th>Aluno</th>
                                            <th>Vendedor</th>
                                            <th>Fotos</th>
                                            <th>Status</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {relacoesAlunoVendedor.map((relacao) => {
                                            const aluno = listAluno.find(a => a.id === relacao.alunoId)
                                                || alunosPendentesInfo[relacao.alunoId];

                                            return (
                                                <tr key={relacao.alunoId}>
                                                    <td>{aluno?.referenceCode ?? "-"}</td>
                                                    <td>{aluno?.name || "-"}</td>
                                                    <td>
                                                        {listVendedores.find(v => v.id === relacao.vendedorId)?.name || "-"}
                                                    </td>
                                                    <td>{relacao.numberPhotos}</td>
                                                    <td>{getRelacaoStatusLabel(Number(relacao.status))}</td>
                                                    <td>
                                                        <Button
                                                            style={{ color: "#FFF", backgroundColor: "#585858", marginRight: "5px" }}
                                                            size="sm"
                                                            onClick={() => {
                                                                const alunoInfo = listAluno.find(a => a.id === relacao.alunoId) || alunosPendentesInfo[relacao.alunoId];
                                                                if (alunoInfo?.referenceCode) {
                                                                    setCodigoAluno(alunoInfo.referenceCode);
                                                                }
                                                                setNumeroFotos(relacao.numberPhotos || 0);
                                                                if (relacao.vendedorId) {
                                                                    setVendedorAtivo(relacao.vendedorId);
                                                                }
                                                                setRelacoesAlunoVendedor(prev =>
                                                                    prev.filter(r => r.alunoId !== relacao.alunoId)
                                                                );
                                                                setTimeout(() => document.getElementById("inputFotos")?.focus(), 100);
                                                            }}
                                                        >
                                                            <i className="fa-solid fa-pen-to-square"></i>
                                                        </Button>
                                                        <Button
                                                            color="danger"
                                                            size="sm"
                                                            onClick={() =>
                                                                setRelacoesAlunoVendedor(prev =>
                                                                    prev.filter(r => r.alunoId !== relacao.alunoId)
                                                                )
                                                            }
                                                        >
                                                            x
                                                        </Button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            )}
                        </>
                    )}
                </ModalBody>
            </Modal >

            <Modal isOpen={editModalOpen} toggle={() => setEditModalOpen(!editModalOpen)} backdrop="static" size="xl">
                <ModalHeader toggle={() => setEditModalOpen(!editModalOpen)}>Editar Relatório de Venda</ModalHeader>
                <ModalBody>
                    {editingRelatorioVenda && (
                        // <Form onSubmit={handleEditSubmit}>
                        <div>
                            <Row>
                                <Col md="6">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="contratoId">
                                            Contrato
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="select"
                                            name="contratoId"
                                            id="contratoId"
                                            value={editingRelatorioVenda.contratoId}
                                            onChange={handleEditInputChange}
                                            disabled
                                        >
                                            <option value={0}>Selecione um Contrato</option>
                                            {listContrato.map((contrato) => (
                                                <option key={contrato.id} value={contrato.id}>
                                                    {`${contrato.id} - ${contrato.description}`}
                                                </option>
                                            ))}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="date">
                                            Data de Saída para Venda
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="date"
                                            name="date"
                                            id="date"
                                            value={editingRelatorioVenda.date?.toString() || ""}
                                            onChange={handleEditInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="status">
                                            Status
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="select"
                                            name="status"
                                            id="status"
                                            value={editingRelatorioVenda.status}
                                            onChange={handleEditInputChange}
                                        >
                                            <option value={0}>Selecione um Status</option>
                                            <option value={1}>Ativo</option>
                                            <option value={2}>Baixado</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="vendedores">
                                            Vendedor(es) Atual(is) do Relatório
                                        </Label>
                                        {vendedoresVinculadosUnicos.length > 0 ? (
                                            <div className="d-flex flex-wrap mb-2">
                                                {vendedoresVinculadosUnicos.map((v) => (
                                                    <span key={v.id} className="badge badge-primary mr-2 mb-1" style={{ fontSize: '13px', padding: '6px 10px' }}>
                                                        <i className="fa-solid fa-user-tie mr-1"></i> {v.nome}
                                                    </span>
                                                ))}
                                            </div>
                                        ) : (
                                            <div className="text-muted small mb-2">Nenhum vendedor vinculado ainda.</div>
                                        )}
                                        <div className="d-flex align-items-center mt-2">
                                            <div style={{ flex: 1 }} className="mr-2">
                                                <Select
                                                    options={vendedorOptions}
                                                    value={vendedorOptions.find(opt => opt.value === novoVendedorRelatorio) || null}
                                                    onChange={(opt) => setNovoVendedorRelatorio(opt?.value || 0)}
                                                    placeholder="Alterar vendedor de todo o relatório..."
                                                    isClearable
                                                    menuPortalTarget={document.body}
                                                    styles={{
                                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    }}
                                                />
                                            </div>
                                            <Button
                                                color="warning"
                                                size="sm"
                                                style={{ whiteSpace: 'nowrap' }}
                                                onClick={handleAlterarVendedorRelatorio}
                                                disabled={!novoVendedorRelatorio}
                                                title="Altera o vendedor de todos os lançamentos deste relatório"
                                            >
                                                <i className="fa-solid fa-user-pen mr-1"></i> Alterar Vendedor
                                            </Button>
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="checked">
                                            Conferido
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="select"
                                            name="checked"
                                            id="checked"
                                            value={editingRelatorioVenda.checked ? "true" : "false"}
                                            onChange={(e) => {
                                                const checked = e.target.value === "true";
                                                setEditingRelatorioVenda(prev => ({
                                                    ...prev!,
                                                    checked,
                                                    dateChecked: checked ? (prev?.dateChecked || new Date().toISOString().split('T')[0]) : "",
                                                }));
                                            }}
                                        >
                                            <option value="false">Não</option>
                                            <option value="true">Sim</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="dateChecked">
                                            Data Conferido
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="date"
                                            name="dateChecked"
                                            id="dateChecked"
                                            value={editingRelatorioVenda.dateChecked?.toString().split('T')[0] || ""}
                                            onChange={handleEditInputChange}
                                            disabled={!editingRelatorioVenda.checked}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="d-flex justify-content-end mt-3">
                                <Button
                                    style={{ color: "#FFF", backgroundColor: "#585858" }}
                                    // type="submit"
                                    onClick={handleEditSubmit}
                                    size="m"
                                >
                                    Salvar alterações
                                </Button>
                                <Button
                                    style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                                    className="ml-2"
                                    onClick={() => setEditModalOpen(false)}
                                    size="m"
                                >
                                    Cancelar
                                </Button>
                            </div>
                            {editingRelatorioVenda && (
                                <>
                                    <hr />
                                    <h4>
                                        {editingRelatorioVenda.contratoId
                                            ? "Selecionar novos alunos do contrato"
                                            : "Adicionar novos formandos por código"}
                                    </h4>
                                    {!editingRelatorioVenda.contratoId && (
                                        <small className="text-muted d-block mb-2">
                                            Este relatório não está vinculado a um contrato. Informe o código do formando para adicioná-lo.
                                        </small>
                                    )}
                                    <Form onSubmit={adicionarAlunoManualEdicao} className="mb-4">
                                        <Row>
                                            <Col md="3">
                                                <Label className="form-control-label">Código do Aluno</Label>
                                                <Input
                                                    id="codigoAlunoInputEdicao"
                                                    className="form-control-alternative"
                                                    type="number"
                                                    value={codigoAlunoEdicao || ""}
                                                    onChange={(e) => setCodigoAlunoEdicao(Number(e.target.value))}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            e.preventDefault();
                                                            document.getElementById("inputFotosEdicao")?.focus();
                                                        }
                                                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    onWheel={(e) => e.currentTarget.blur()}
                                                />
                                                <div className="mt-1">
                                                    <small className="text-muted d-block" style={{ minHeight: '18px', fontWeight: 500 }}>
                                                        {buscandoNomeFormandoEdicao ? "Buscando nome..." : (nomeFormandoEdicao ? `Formando: ${nomeFormandoEdicao}` : (codigoAlunoEdicao ? "Aluno não encontrado" : ""))}
                                                    </small>
                                                </div>
                                            </Col>

                                            <Col md="3">
                                                <Label className="form-control-label">Número de Fotos</Label>
                                                <Input
                                                    className="form-control-alternative"
                                                    type="number"
                                                    id="inputFotosEdicao"
                                                    value={numeroFotosEdicao || ""}
                                                    onChange={(e) => setNumeroFotosEdicao(Number(e.target.value))}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            e.preventDefault();
                                                            adicionarAlunoManualEdicao(e);
                                                        }
                                                        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    onWheel={(e) => e.currentTarget.blur()}
                                                    disabled={!codigoAlunoEdicao || isAddingAlunoEdicao}
                                                />
                                            </Col>

                                            <Col md="4">
                                                <Label className="form-control-label">Vendedor</Label>
                                                <Select
                                                    className="form-control-alternative"
                                                    value={selectedVendedor}
                                                    onChange={(selectedOption) =>
                                                        setVendedorAtivoEdicao(selectedOption?.value || 0)
                                                    }
                                                    options={vendedorOptions}
                                                    placeholder="Selecione ou pesquise um vendedor"
                                                    isClearable
                                                    isSearchable
                                                />
                                            </Col>

                                            <Col md="2" className="d-flex align-items-start" style={{ paddingTop: '32px' }}>
                                                <Button 
                                                    style={{ color: "#FFF", backgroundColor: "#585858" }} 
                                                    type="submit"
                                                    disabled={isAddingAlunoEdicao}
                                                >
                                                    {isAddingAlunoEdicao ? "Adicionando..." : "Adicionar"}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </>
                            )}

                            {alunosVinculados.length > 0 && (
                                <>
                                    <hr />
                                    <h4>Alunos vinculados</h4>
                                    <>
                                    <Form onSubmit={handleAlunoVendedorSearchSubmit} className='mt-4'>
                                        <Row className="align-items-center mb-4">
                                            <Col xs="12" md="4" lg="4" className="mb-2">
                                                <FormGroup>
                                                    <Label className="form-control-label" htmlFor="name">Nome do Aluno</Label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        type="text"
                                                        name="name"
                                                        id="name"
                                                        placeholder="Buscar por nome"
                                                        value={alunoVendedorSearch.name}
                                                        onChange={(e) => setAlunoVendedorSearch({ ...alunoVendedorSearch, name: e.target.value })}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col xs="12" md="4" lg="4" className="mb-2">
                                                <FormGroup>
                                                    <Label className="form-control-label" htmlFor="alunoId">Código do Aluno</Label>
                                                    <Input
                                                        className="form-control-alternative"
                                                        type="number"
                                                        name="alunoId"
                                                        id="alunoId"
                                                        placeholder="Buscar por Código"
                                                        value={alunoVendedorSearch.alunoId}
                                                        onChange={(e) => setAlunoVendedorSearch({ ...alunoVendedorSearch, alunoId: e.target.value })}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col xs="12" md="4" lg="4" className="d-flex justify-content-start justify-content-md-end mb-2">
                                                <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit" size="m" className="mr-2">
                                                    Buscar
                                                </Button>
                                                <Button
                                                    style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                                                    type="button"
                                                    size="m"
                                                    onClick={() => {
                                                        setAlunoVendedorSearch({ name: "", alunoId: "" });
                                                        if (editingRelatorioVenda?.id) {
                                                            getAlunosVendedoresPaged(editingRelatorioVenda.id, 1, 10);
                                                        }
                                                    }}
                                                >
                                                    Limpar
                                                </Button>
                                            </Col>
                                        </Row>
                                        <Row className="align-items-center mb-3">
                                            <Col xs="12" md="4" lg="4">
                                                <FormGroup>
                                                    <Label className="form-control-label" htmlFor="vendedorFiltroPdf">Filtrar por Vendedor</Label>
                                                    <Select
                                                        id="vendedorFiltroPdf"
                                                        className="form-control-alternative"
                                                        options={vendedorOptions}
                                                        value={vendedorOptions.find(opt => opt.value === vendedorAtivoEdicao) || null}
                                                        onChange={(selectedOption) => setVendedorAtivoEdicao(selectedOption?.value || 0)}
                                                        placeholder="Selecione um vendedor"
                                                        isClearable
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        }}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col xs="12" md="4" lg="4">
                                                <FormGroup>
                                                    <Label className="form-control-label" htmlFor="statusFiltroPdf">Filtrar por Status</Label>
                                                    <Input
                                                        id="statusFiltroPdf"
                                                        className="form-control-alternative"
                                                        type="select"
                                                        value={novoStatusLote}
                                                        onChange={(e) => setNovoStatusLote(Number(e.target.value))}
                                                    >
                                                        <option value={0}>Todos os status</option>
                                                        <option value={1}>Em rota</option>
                                                        <option value={2}>Roteiro</option>
                                                        <option value={3}>Retorno</option>
                                                        <option value={4}>Devolvido</option>
                                                        <option value={5}>Vendido</option>
                                                        <option value={6}>Descartado</option>
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                            <Col xs="12" md="12" lg="12" className="d-flex flex-wrap align-items-center justify-content-end mt-2" style={{ gap: '8px' }}>
                                                <Button
                                                    color="info"
                                                    onClick={() =>
                                                        handlePreviewRelatorio(
                                                            editingRelatorioVenda!.id,
                                                            false,
                                                            vendedorAtivoEdicao !== 0 ? vendedorAtivoEdicao : undefined,
                                                            novoStatusLote !== 0 ? novoStatusLote : undefined
                                                        )
                                                    }
                                                >
                                                    <i className="fa-solid fa-print mr-2"></i> Pré-visualizar / Imprimir
                                                </Button>
                                                <Button
                                                    color="secondary"
                                                    onClick={() =>
                                                        handlePreviewRelatorio(
                                                            editingRelatorioVenda!.id,
                                                            true,
                                                            vendedorAtivoEdicao !== 0 ? vendedorAtivoEdicao : undefined,
                                                            novoStatusLote !== 0 ? novoStatusLote : undefined
                                                        )
                                                    }
                                                >
                                                    <i className="fa-solid fa-print mr-2"></i> Pré-visualizar Reduzido
                                                </Button>
                                                <Button
                                                    style={{ backgroundColor: '#007bff', color: '#FFF' }}
                                                    onClick={() =>
                                                        downloadRelatorioVendaPdf(
                                                            editingRelatorioVenda!.id,
                                                            vendedorAtivoEdicao !== 0 ? vendedorAtivoEdicao : undefined,
                                                            novoStatusLote !== 0 ? novoStatusLote : undefined
                                                        )
                                                    }
                                                >
                                                    <i className="fa-solid fa-download mr-2"></i> Baixar PDF
                                                </Button>
                                                <Button
                                                    style={{ backgroundColor: '#007bff', color: '#FFF' }}
                                                    onClick={() =>
                                                        downloadRelatorioReduzidoVendaPdf(
                                                            editingRelatorioVenda!.id,
                                                            vendedorAtivoEdicao !== 0 ? vendedorAtivoEdicao : undefined,
                                                            novoStatusLote !== 0 ? novoStatusLote : undefined
                                                        )
                                                    }
                                                >
                                                    <i className="fa-solid fa-download mr-2"></i> Baixar Reduzido
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>

                                    {alunosSelecionadosIds.length > 0 && (
                                        <div className="p-3 mb-3" style={{ backgroundColor: '#f4f5f7', borderRadius: '8px', border: '1px solid #e9ecef', position: 'relative', zIndex: 10 }}>
                                            <div className="d-flex align-items-center justify-content-between mb-2">
                                                <strong className="text-primary" style={{ fontSize: '14px' }}>
                                                    <i className="fa-solid fa-check-double mr-1"></i> {alunosSelecionadosIds.length} formando(s) selecionado(s)
                                                </strong>
                                                <Button size="sm" color="link" className="p-0 text-muted" onClick={() => setAlunosSelecionadosIds([])}>
                                                    Limpar seleção
                                                </Button>
                                            </div>
                                            <Row>
                                                <Col md="6" className="mb-2 mb-md-0">
                                                    <Label className="form-control-label mb-1" style={{ fontSize: '12px' }}>Alterar Vendedor dos selecionados</Label>
                                                    <div className="d-flex">
                                                        <div style={{ flex: 1 }} className="mr-2">
                                                            <Select
                                                                options={vendedorOptions}
                                                                value={vendedorOptions.find(opt => opt.value === novoVendedorLote) || null}
                                                                onChange={(opt) => setNovoVendedorLote(opt?.value || 0)}
                                                                placeholder="Selecione o vendedor..."
                                                                isClearable
                                                                menuPortalTarget={document.body}
                                                                styles={{
                                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                                }}
                                                            />
                                                        </div>
                                                        <Button
                                                            color="warning"
                                                            size="sm"
                                                            onClick={aplicarNovoVendedorLote}
                                                            disabled={!novoVendedorLote}
                                                        >
                                                            Aplicar Vendedor
                                                        </Button>
                                                    </div>
                                                </Col>
                                                <Col md="6">
                                                    <Label className="form-control-label mb-1" style={{ fontSize: '12px' }}>Alterar Status dos selecionados</Label>
                                                    <div className="d-flex">
                                                        <Input
                                                            className="form-control-alternative mr-2"
                                                            type="select"
                                                            value={novoStatusLote}
                                                            onChange={(e) => setNovoStatusLote(Number(e.target.value))}
                                                        >
                                                            <option value={0}>Selecione um status</option>
                                                            <option value={1}>Em rota</option>
                                                            <option value={2}>Roteiro</option>
                                                            <option value={3}>Retorno</option>
                                                            <option value={4}>Devolvido</option>
                                                            <option value={5}>Vendido</option>
                                                            <option value={6}>Descartado</option>
                                                            <option value={7}>Recusou Álbum</option>
                                                        </Input>
                                                        <Button
                                                            style={{ color: "#FFF", backgroundColor: "#585858", whiteSpace: 'nowrap' }}
                                                            size="sm"
                                                            onClick={aplicarNovoStatusLote}
                                                            disabled={novoStatusLote === 0}
                                                        >
                                                            Aplicar Status
                                                        </Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    )}

                                    {/* Item 14: Confirmação em uma única vez para todos os status alterados */}
                                    {Object.keys(statusEmEdicaoPorAluno).length > 0 && (
                                        <div className="alert alert-success d-flex justify-content-between align-items-center mb-3 py-2 px-3 shadow-sm border-0">
                                            <div>
                                                <i className="fa-solid fa-circle-check mr-2 fa-lg"></i>
                                                <strong>{Object.keys(statusEmEdicaoPorAluno).length}</strong> formando(s) com status modificado(s) aguardando confirmação.
                                            </div>
                                            <div style={{ gap: '8px' }} className="d-flex">
                                                <Button
                                                    color="light"
                                                    size="sm"
                                                    onClick={() => setStatusEmEdicaoPorAluno({})}
                                                    disabled={salvandoStatusIndividual}
                                                >
                                                    Descartar alterações
                                                </Button>
                                                <Button
                                                    color="success"
                                                    size="sm"
                                                    onClick={handleSalvarTodosStatus}
                                                    disabled={salvandoStatusIndividual}
                                                    className="font-weight-bold"
                                                >
                                                    {salvandoStatusIndividual ? (
                                                        <>
                                                            <i className="fa-solid fa-spinner fa-spin mr-1"></i> Confirmando...
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="fa-solid fa-check-double mr-1"></i> Confirmar Baixa / Salvar Todos
                                                        </>
                                                    )}
                                                </Button>
                                            </div>
                                        </div>
                                    )}

                                    <div style={{ maxHeight: '450px', overflowY: 'auto', overflowX: 'hidden' }}>
                                        <Table striped className="table-striped mb-0" style={{ width: '100%', fontSize: '13px' }}>
                                            <thead style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#f8f9fe' }}>
                                                <tr>
                                                    <th style={{ width: '40px', textAlign: 'center', verticalAlign: 'middle', padding: '8px 4px' }}>
                                                        <input
                                                            type="checkbox"
                                                            id="checkTodosAlunos"
                                                            checked={todosSelecionados}
                                                            onChange={toggleSelecionarTodos}
                                                            style={{ cursor: 'pointer', width: '16px', height: '16px', verticalAlign: 'middle' }}
                                                        />
                                                    </th>
                                                    <th style={{ width: '70px', padding: '8px 6px' }}>Código</th>
                                                    <th style={{ padding: '8px 6px' }}>Nome do Aluno</th>
                                                    <th style={{ width: '90px', padding: '8px 6px' }}>Nº Vendedor</th>
                                                    <th style={{ padding: '8px 6px' }}>Nome do Vendedor</th>
                                                    <th style={{ padding: '8px 6px' }}>Curso</th>
                                                    <th style={{ width: '70px', textAlign: 'center', padding: '8px 6px' }}>Fotos</th>
                                                    <th style={{ width: '150px', padding: '8px 6px' }}>Status</th>
                                                    <th style={{ width: '90px', textAlign: 'center', padding: '8px 6px' }}>Ações</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {listRelacaoAlunosVendedores
                                                    .sort((a, b) => (a.alunoNome || '').localeCompare(b.alunoNome || ''))
                                                    .map((item, index) => {
                                                        const currentStatus = statusEmEdicaoPorAluno[item.id] !== undefined
                                                            ? statusEmEdicaoPorAluno[item.id]
                                                            : item.status;
                                                        const isModificado = statusEmEdicaoPorAluno[item.id] !== undefined && statusEmEdicaoPorAluno[item.id] !== item.status;

                                                        return (
                                                            <tr key={index} style={{ backgroundColor: isModificado ? '#fff3cd' : getStatusRowColor(item.status) }}>
                                                                <td style={{ width: '40px', textAlign: 'center', verticalAlign: 'middle', padding: '6px 4px' }}>
                                                                    <input
                                                                        type="checkbox"
                                                                        id={`checkAluno_${item.alunoId}`}
                                                                        checked={alunosSelecionadosIds.includes(item.alunoId)}
                                                                        onChange={() => toggleAlunoSelecionado(item.alunoId)}
                                                                        style={{ cursor: 'pointer', width: '16px', height: '16px', verticalAlign: 'middle' }}
                                                                    />
                                                                </td>
                                                                <td style={{ padding: '6px' }}>{item.alunoId}</td>
                                                                <td style={{ padding: '6px' }}>
                                                                    <strong>{item.alunoNome}</strong>
                                                                    {item.permissaoVendaRestricao && (
                                                                        <span
                                                                            className="badge badge-warning ml-2"
                                                                            title="Permissão de venda com restrição (bloqueado/sinalizado para cobrança)"
                                                                            style={{ fontSize: '10px' }}
                                                                        >
                                                                            <i className="fa-solid fa-triangle-exclamation mr-1"></i> Restrição
                                                                        </span>
                                                                    )}
                                                                </td>
                                                                <td style={{ padding: '6px' }}>{item.vendedorId}</td>
                                                                <td style={{ padding: '6px' }}>{item.vendedorNome}</td>
                                                                <td style={{ padding: '6px' }}>{item.cursoNome}</td>
                                                                <td style={{ textAlign: 'center', padding: '6px' }}>{item.numberPhotos}</td>
                                                                <td style={{ padding: '6px' }}>
                                                                    <div className="d-flex align-items-center">
                                                                        <Input
                                                                            type="select"
                                                                            bsSize="sm"
                                                                            className="form-control-alternative font-weight-bold"
                                                                            style={{
                                                                                fontSize: '12px',
                                                                                borderColor: isModificado ? '#ffc107' : undefined,
                                                                                boxShadow: isModificado ? '0 0 4px rgba(255, 193, 7, 0.6)' : undefined
                                                                            }}
                                                                            value={currentStatus}
                                                                            onChange={(e) => handleChangeStatusIndividual(item.id, Number(e.target.value))}
                                                                        >
                                                                            <option value={0}>Selecione</option>
                                                                            <option value={1}>Em rota</option>
                                                                            <option value={2}>Roteiro</option>
                                                                            <option value={3}>Retorno</option>
                                                                            <option value={4}>Devolvido</option>
                                                                            <option value={5}>Vendido</option>
                                                                            <option value={6}>Descartado</option>
                                                                            <option value={7}>Recusou Álbum</option>
                                                                        </Input>
                                                                        {isModificado && (
                                                                            <span className="badge badge-warning ml-1" title="Alteração pendente de confirmação">
                                                                                *
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                                <td style={{ textAlign: 'center', whiteSpace: 'nowrap', padding: '6px' }}>
                                                                    <Button size="sm" className="p-1 mr-1" onClick={() => handleEditRelacaoRelatorioVenda(item)}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                                    <Button
                                                                        size="sm"
                                                                        className="p-1"
                                                                        color="danger"
                                                                        onClick={() => {
                                                                            if (!editingRelatorioVenda) return;
                                                                            setPendingRemoverRelacao({ alunoId: item.alunoId, vendedorId: item.vendedorId });
                                                                        }}
                                                                    >
                                                                        <i className="fa-solid fa-trash"></i>
                                                                    </Button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mt-3">
                                        <small className="text-muted">
                                            Exibindo {listRelacaoAlunosVendedores.length} aluno(s) em ordem alfabética.
                                        </small>
                                        {relacaoAlunosVendedoresPageCount > 1 && (
                                            <div className="d-flex justify-content-center">
                                                <PaginationMaterial
                                                    onChange={(e: any, value: any) => onChangeAlunoVendedorPagination(e, value)}
                                                    count={relacaoAlunosVendedoresPageCount}
                                                />
                                            </div>
                                        )}
                                        {listRelacaoAlunosVendedores.length === 0 && (
                                            <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                        )}
                                    </div>
                                    </>
                                </>
                            )}
                        </div>
                        // </Form>
                    )}
                </ModalBody>
            </Modal>
            <Modal isOpen={editRelacaoModalOpen} toggle={() => setEditRelacaoModalOpen(!editRelacaoModalOpen)} backdrop="static" size="xl">
                <ModalHeader toggle={() => setEditRelacaoModalOpen(!editRelacaoModalOpen)}>Editar Relação</ModalHeader>
                <ModalBody>
                    {editingRelacaoRelatorioVenda && (
                        <Form onSubmit={handleRelacaoEditSubmit}>
                            <Row>
                                <Col md="12">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="numberPhotos">
                                            Número de fotos
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="number"
                                            name="numberPhotos"
                                            id="numberPhotos"
                                            value={editingRelacaoRelatorioVenda.numberPhotos}
                                            onChange={handleEditRelacaoInputChange}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="vendedorId">
                                            Vendedor
                                        </Label>
                                        <Select
                                            className="form-control-alternative"
                                            options={vendedorOptions}
                                            value={vendedorOptions.find(opt => opt.value === editingRelacaoRelatorioVenda.vendedorId)}
                                            onChange={(selectedOption) =>
                                                setEditingRelacaoRelatorioVenda(prev => ({
                                                    ...prev!,
                                                    vendedorId: selectedOption?.value || 0
                                                }))
                                            }
                                            placeholder="Selecione ou digite para buscar..."
                                            isClearable
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="status">
                                            Status
                                        </Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="select"
                                            name="status"
                                            id="status"
                                            value={editingRelacaoRelatorioVenda.status}
                                            onChange={handleEditRelacaoInputChange}
                                        >
                                            <option value={0}>Selecione um Status</option>
                                            <option value={1}>Em rota</option>
                                            <option value={2}>Roteiro</option>
                                            <option value={3}>Retorno</option>
                                            <option value={4}>Devolvido</option>
                                            <option value={5}>Vendido</option>
                                            <option value={6}>Descartado</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md="12">
                                    <FormGroup check className="mt-2">
                                        <Label check style={{ cursor: 'pointer', fontWeight: 600 }}>
                                            <Input
                                                type="checkbox"
                                                name="permissaoVendaRestricao"
                                                id="permissaoVendaRestricao"
                                                checked={!!editingRelacaoRelatorioVenda.permissaoVendaRestricao}
                                                onChange={handleEditRelacaoInputChange}
                                            />{' '}
                                            <span className="text-warning font-weight-bold">
                                                <i className="fa-solid fa-triangle-exclamation mr-1"></i> Permissão de venda com restrição
                                            </span>
                                            <small className="d-block text-muted">
                                                Marque caso este cliente possua restrição para acompanhamento específico na cobrança.
                                            </small>
                                        </Label>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="d-flex justify-content-end mt-3">
                                <Button
                                    style={{ color: "#FFF", backgroundColor: "#585858" }}
                                    type="submit"
                                    size="m"
                                >
                                    Salvar alterações
                                </Button>
                                <Button
                                    style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                                    className="ml-2"
                                    onClick={() => setEditRelacaoModalOpen(false)}
                                    size="m"
                                >
                                    Cancelar
                                </Button>
                            </div>
                        </Form>
                    )}
                </ModalBody>
            </Modal>
            <Modal
                isOpen={exportModalOpen}
                toggle={() => setExportModalOpen(!exportModalOpen)}
                backdrop="static"
            >
                <ModalHeader toggle={() => setExportModalOpen(!exportModalOpen)}>
                    Exportar Relatório de Vendas Ativas
                </ModalHeader>
                <ModalBody>
                    <Form>
                        <FormGroup>
                            <Label className="form-control-label">
                                Selecione um vendedor (opcional)
                            </Label>
                            <Select
                                className="form-control-alternative"
                                options={vendedorOptions}
                                value={vendedorOptions.find(
                                    (v) => v.value === vendedorFiltroExport
                                ) || null}
                                onChange={(opt) =>
                                    setVendedorFiltroExport(opt?.value || 0)
                                }
                                placeholder="Digite para filtrar vendedores…"
                                isClearable
                                isSearchable
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Status (opcional)</Label>
                            <Input
                                type="select"
                                value={statusFiltroExport}
                                onChange={(e) => setStatusFiltroExport(Number(e.target.value))}
                            >
                                <option value={0}>Todos</option>
                                <option value={1}>Em rota</option>
                                <option value={2}>Roteiro</option>
                                <option value={3}>Retorno</option>
                                <option value={4}>Devolvido</option>
                                <option value={5}>Vendido</option>
                                <option value={6}>Descartado</option>
                            </Input>
                        </FormGroup>
                        <Row>
                            <Col xs="6">
                                <FormGroup>
                                    <Label className="form-control-label" for="InitialDateExport">Data Inicial (opcional)</Label>
                                    <Input
                                        type="date"
                                        id="InitialDateExport"
                                        value={initialDateFiltroExport}
                                        onChange={(e) => setInitialDateFiltroExport(e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs="6">
                                <FormGroup>
                                    <Label className="form-control-label" for="FinalDateExport">Data Final (opcional)</Label>
                                    <Input
                                        type="date"
                                        id="FinalDateExport"
                                        value={finalDateFiltroExport}
                                        onChange={(e) => setFinalDateFiltroExport(e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <small className="text-muted">
                            As datas vêm da busca da tela. Deixe em branco para exportar todos os relatórios ativos.
                        </small>
                    </Form>
                </ModalBody>
                <ModalFooter className="d-flex justify-content-end">
                    <Button
                        style={{ backgroundColor: '#007bff', color: '#FFF' }}
                        onClick={async () => {
                            await downloadRelatorioVendasAtivasPdf(
                                objUserTk.EmpresaId,
                                vendedorFiltroExport || undefined,
                                statusFiltroExport || undefined,
                                initialDateFiltroExport || undefined,
                                finalDateFiltroExport || undefined
                            );
                            setExportModalOpen(false);
                        }}
                    >
                        <i className="fa-solid fa-file-pdf mr-2"></i>
                        Exportar PDF
                    </Button>
                    <Button
                        style={{ backgroundColor: '#d9534f', color: '#FFF' }}
                        onClick={() => setExportModalOpen(false)}
                    >
                        Cancelar
                    </Button>
                </ModalFooter>
            </Modal>

            <ModalConfirm
                openModal={confirmDeleteRelatorioVendaId !== null}
                closeModal={() => setConfirmDeleteRelatorioVendaId(null)}
                handleConfirm={executeDeleteRelatorioVenda}
                title="Excluir relatório"
                message="Tem certeza que deseja excluir este relatório? Esta ação não pode ser desfeita."
            />

            <ModalConfirm
                openModal={pendingRemoverRelacao !== null}
                closeModal={() => setPendingRemoverRelacao(null)}
                handleConfirm={executeRemoverRelacaoRelatorioVenda}
                title="Remover vínculo"
                message="Deseja realmente remover esse vínculo entre aluno e vendedor?"
            />

            {/* Modal de Pré-visualização e Impressão do Relatório */}
            <Modal
                isOpen={previewModalOpen}
                toggle={closePreviewModal}
                size="xl"
                style={{ maxWidth: '92vw' }}
            >
                <ModalHeader toggle={closePreviewModal} className="d-flex align-items-center justify-content-between">
                    <span className="font-weight-bold" style={{ color: '#0d2b45' }}>
                        <i className="fa-solid fa-file-invoice mr-2"></i> {previewPdfTitle || "Pré-visualização do Relatório"}
                    </span>
                </ModalHeader>
                <ModalBody className="p-2" style={{ backgroundColor: '#525659' }}>
                    {previewLoading ? (
                        <div className="d-flex flex-column justify-content-center align-items-center py-5 text-white" style={{ minHeight: '600px' }}>
                            <Spinner color="light" style={{ width: '3rem', height: '3rem' }} />
                            <span className="mt-3 font-weight-bold">Gerando pré-visualização do relatório...</span>
                        </div>
                    ) : previewPdfUrl ? (
                        <iframe
                            id="pdfPreviewIframe"
                            src={previewPdfUrl}
                            title="Visualização do Relatório"
                            style={{
                                width: '100%',
                                height: '78vh',
                                border: 'none',
                                borderRadius: '4px',
                                backgroundColor: '#fff'
                            }}
                        />
                    ) : (
                        <div className="text-center py-5 text-white">
                            Nenhum documento disponível para visualização.
                        </div>
                    )}
                </ModalBody>
                <ModalFooter className="d-flex justify-content-between">
                    <div>
                        <small className="text-muted">
                            <i className="fa-solid fa-info-circle mr-1"></i> Você pode imprimir diretamente ou salvar o arquivo em seu computador.
                        </small>
                    </div>
                    <div className="d-flex" style={{ gap: '8px' }}>
                        <Button
                            color="primary"
                            onClick={handlePrintPreview}
                            disabled={!previewPdfUrl || previewLoading}
                        >
                            <i className="fa-solid fa-print mr-2"></i> Imprimir
                        </Button>
                        <Button
                            color="success"
                            onClick={() => handleDownloadCurrentPreview(previewPdfTitle)}
                            disabled={!previewPdfUrl || previewLoading}
                        >
                            <i className="fa-solid fa-download mr-2"></i> Baixar Arquivo
                        </Button>
                        <Button
                            color="secondary"
                            onClick={closePreviewModal}
                        >
                            Fechar
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default RelatorioVenda;
